import { DATASETS } from '@/components/Constants';

export function buildNumPmidMappingConfig(
  rowData: Record<string, unknown>,
  view: string,
  tab: string,
  searchItems: Array<{ chemID?: string; chemPrefName?: string }>,
): {
  name: string;
  tabSegment: string;
  viewSegment: string;
  mappingItems: Array<{
    filterParam: string;
    filterValue: string | number | undefined;
    name?: string;
    id?: string | number;
  }>;
  columVisibilityModelKey: string;
} | null {
  const isChemicalView = view === DATASETS.CHEMICALS;

  if (isChemicalView) {
    const chemOfInterest = searchItems?.map(item => ({
      filterParam: 'chem_ids_filter' as const,
      filterValue: item?.chemID,
      name: item?.chemPrefName,
      id: item?.chemID,
    }))?.[0];

    if (!chemOfInterest) return null;

    if (tab === 'GDA') {
      return {
        name: 'numPMIDsupportingAssociation',
        tabSegment: 'gda',
        viewSegment: '/summary',
        columVisibilityModelKey: 'numPMIDsupportingAssociationGDA',
        mappingItems: [
          {
            filterParam: 'disease',
            filterValue: rowData.diseaseUMLSCUI as string,
            name: rowData.diseaseName as string,
            id: rowData.diseaseUMLSCUI as string,
          },
          {
            filterParam: 'gene_ncbi_id',
            filterValue: rowData.geneNcbiID as string | number,
            name: rowData.geneSymbol as string,
            id: rowData.geneDescription as string,
          },
          chemOfInterest,
        ],
      };
    }

    if (tab === 'VDA') {
      return {
        name: 'numPMIDsupportingAssociation',
        tabSegment: 'vda',
        viewSegment: '/summary',
        columVisibilityModelKey: 'numPMIDsupportingAssociationVDA',
        mappingItems: [
          {
            filterParam: 'disease',
            filterValue: rowData.diseaseUMLSCUI as string,
            name: rowData.diseaseName as string,
            id: rowData.diseaseUMLSCUI as string,
          },
          {
            filterParam: 'variant',
            filterValue: rowData.variantStrID as string,
            name: rowData.variantStrID as string,
            id: rowData.geneSymbol as string,
          },
          chemOfInterest,
        ],
      };
    }

    return null;
  }

  if (tab === 'GDA') {
    return {
      name: 'numPMIDsupportingAssociation',
      tabSegment: 'gda',
      viewSegment: '/summary',
      columVisibilityModelKey: 'numPMIDsupportingAssociationGDA',
      mappingItems: [
        {
          filterParam: 'disease',
          filterValue: rowData.diseaseUMLSCUI as string,
          name: rowData.diseaseName as string,
          id: rowData.diseaseUMLSCUI as string,
        },
        {
          filterParam: 'gene_ncbi_id',
          filterValue: rowData.geneNcbiID as string | number,
          name: rowData.geneSymbol as string,
          id: rowData.geneDescription as string,
        },
      ],
    };
  }

  if (tab === 'VDA') {
    return {
      name: 'numPMIDsupportingAssociation',
      tabSegment: 'vda',
      viewSegment: '/summary',
      columVisibilityModelKey: 'numPMIDsupportingAssociationVDA',
      mappingItems: [
        {
          filterParam: 'disease',
          filterValue: rowData.diseaseUMLSCUI as string,
          name: rowData.diseaseName as string,
          id: rowData.diseaseUMLSCUI as string,
        },
        {
          filterParam: 'variant',
          filterValue: rowData.variantStrID as string,
          name: rowData.variantStrID as string,
          id: rowData.geneSymbol as string,
        },
      ],
    };
  }

  return null;
}
